var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-modal d-flex justify-content-center align-items-center",class:{
		'is-open': _vm.value,
		'is-dark': this.$root.dark_mode === true,
	}},[_c('button',{staticClass:"c-modal__close",attrs:{"aria-label":"Close map modal"},on:{"click":function($event){return _vm.close_modal()}}},[_c('span',{staticClass:"sidearm-icon sf-close-minimal",attrs:{"aria-hidden":"true"}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }